import { useState, useEffect, useMemo } from "react";
import Fuse from 'fuse.js';

const options = {
    includeScore: true,
    threshold: 0.3,
    keys: ['TITLE']
}

const OutletSearchBox = ({ outlets, goToOutletCoverage }) => {
    const [searchTerm, setSearchTerm] = useState("");
    const [searchResults, setSearchResults] = useState([]);
    const [showResults, setShowResults] = useState(false);

    const fuse = useMemo(() => new Fuse(outlets, options), [outlets]);

    useEffect(() => {
        if (searchTerm.length > 1) {
            const results = fuse.search(searchTerm);
            setSearchResults(results.slice(0, 8)); // Limit to 8 results
            setShowResults(true);
        } else {
            setSearchResults([]);
            setShowResults(false);
        }
    }, [searchTerm, fuse]);

    const handleSelectOutlet = (outlet) => {
        goToOutletCoverage(outlet);
        setSearchTerm("");
        setShowResults(false);
    };

    const clearSearch = () => {
        setSearchTerm("");
        setShowResults(false);
    };

    return <section className="outlet-search-box-section" style={{ position: 'relative' }}>
        <p id="outlet-search-box-label">Search for a news title</p>
        <div style={{ position: 'relative' }}>
            <input
                id="outlet-search-box"
                type="text"
                placeholder="e.g. Manchester Evening News"
                onChange={event => setSearchTerm(event.target.value)}
                value={searchTerm}
            />
            {searchTerm && (
                <button
                    onClick={clearSearch}
                    style={{
                        position: 'absolute',
                        right: '10px',
                        top: '50%',
                        transform: 'translateY(-50%)',
                        background: 'none',
                        border: 'none',
                        cursor: 'pointer',
                        fontSize: '16px',
                        color: '#dfdfdf'
                    }}
                >
                    ×
                </button>
            )}
        </div>

        {showResults && searchResults.length > 0 && (
            <div style={{
                position: 'absolute',
                top: '100%',
                left: 0,
                right: 0,
                backgroundColor: '#265089',
                border: '1px solid rgba(255, 255, 255, 0.16)',
                borderRadius: '6px',
                maxHeight: '200px',
                overflowY: 'auto',
                zIndex: 1000,
                marginTop: '2px'
            }}>
                {searchResults.map((result, index) => (
                    <div
                        key={result.item.ID}
                        onClick={() => handleSelectOutlet(result.item)}
                        style={{
                            padding: '10px 12px',
                            cursor: 'pointer',
                            borderBottom: index < searchResults.length - 1 ? '1px solid rgba(255, 255, 255, 0.16)' : 'none',
                            fontSize: '14px',
                            color: 'white',
                            fontFamily: 'fraktion-sans-regular'
                        }}
                        onMouseEnter={(e) => e.target.style.backgroundColor = 'rgba(255, 255, 255, 0.1)'}
                        onMouseLeave={(e) => e.target.style.backgroundColor = 'transparent'}
                    >
                        {result.item.TITLE}
                    </div>
                ))}
            </div>
        )}
    </section>
}

export default OutletSearchBox;